import { db, auth } from '@/plugins/firebase';
import firebase from 'firebase/app';
import 'firebase/app';
import 'firebase/auth';
import { bus } from '@/main';

export function getUsers({ commit }) {
  let dataArr = [];
  db.collection('users')
    .get()
    .then(async function(docs) {
      if (docs.empty) {
        return;
      }

      for (var i = 0; i < docs.size; i += 1) {
        var doc = docs.docs[i];
        dataArr.push(doc.data());
      }

      commit('updateUsers', dataArr);
    });
}

export function getCurrentUser({ commit }) {
  auth.onAuthStateChanged(function(user) {
    console.log(user);
    if (user) {
      commit('updateAuthUser', auth.currentUser);
    }
  });
}

export async function userRegister({ commit }, { email, password, name }) {
  commit('updateStatus', true);
  auth
    .createUserWithEmailAndPassword(email, password)
    .then((user) => {
      console.log(user.user.uid);
      const ref = db.collection('users').doc(user.user.uid);
      ref.set({
        id: ref.id,
        name: name,
        email: email,
        timestamp: firebase.firestore.FieldValue.serverTimestamp(),
      });
      commit('updateUser', user);
    })
    .then(() => {
      commit('updateAuthStatus', true);
    })
    .catch((err) => {
      console.log(err);
      bus.$emit('show-snackbar', 'Registration Failed: ' + err);
      commit('updateRegistrationError', err);
      commit('updateStatus', false);
    })
    .finally(() => {
      commit('updateStatus', false);
    });
}
export async function userLogin({ commit }, { email, password }) {
  commit('updateStatus', true);
  auth
    .signInWithEmailAndPassword(email, password)
    .then((user) => {
      console.log(user);
      commit('updateUser', user);
      commit('updateAuthStatus', true);
    })
    .catch((err) => {
      bus.$emit('show-snackbar', 'Login Failed: ' + err);
      commit('updateStatus', false);
      commit('updateLoginError', err);
      commit('updateUser', {});
      commit('updateAuthStatus', false);
    })
    .finally(() => {
      commit('updateStatus', false);
    });
}
export async function userSignOut({ commit }) {
  // commit("updateStatus", true);
  auth
    .signOut()
    .then(() => {
      commit('updateUser', {});
      commit('updateAuthUser', null);
    })
    .catch((err) => {
      bus.$emit('show-snackbar', 'Sign Out Failed: ' + err);
      commit('updateUser', {});
      commit('updateAuthUser', null);
      commit('updateAuthStatus', false);
    })
    .finally(() => {
      commit('updateAuthStatus', false);
      // commit("updateStatus", false);
    });
}
export async function forgotPassword({ commit }, { email }) {
  console.log(email);
  auth
    .sendPasswordResetEmail(email)
    .then(function() {
      bus.$emit(
        'show-snackbar',
        'A password reset link has been sent to: ' + email,
      );
    })
    .catch(function(err) {
      bus.$emit('show-snackbar', 'There was an error: ' + err);
    });
}
export async function socialLogin({ commit }, website) {
  return new Promise((resolve, reject) => {
    var provider;
    console.log(website);
    switch (website) {
      case 'google':
        provider = new firebase.auth.GoogleAuthProvider();
        break;
      case 'facebook':
        provider = new firebase.auth.FacebookAuthProvider();
        break;
      default:
        break;
    }

    console.log(provider);
    auth
      .signInWithPopup(provider)
      .then((res) => {
        console.log(res);
        db.collection('users')
          .doc(res.user.uid)
          .get()
          .then((doc) => {
            if (doc.exists) {
              commit('updateUser', res.user);
              resolve();
            } else {
              const ref = db.collection('users').doc(res.user.uid);
              ref.set({
                id: ref.id,
                name: res.user.displayName,
                email: res.user.email,
                createdAt: new Date(),
              });

              commit('updateUser', res.user);
              resolve();
            }
          });
      })
      .catch((err) => {
        bus.$emit('show-snackbar', 'There was an error: ' + err);
        reject();
      });
  });
}
